/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayWidth: NonNullable<unknown> }} Input_Position_X_Dialog_TextInputs */



/**
* | output |
* | --- |
* | "Enter a value between 1 and {displayWidth}:" |
*
* @param {Input_Position_X_Dialog_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_dialog_text = /** @type {((inputs: Input_Position_X_Dialog_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_Dialog_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Entrez une valeur entre 1 et ${i?.displayWidth} :`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Geben Sie einen Wert zwischen 1 und ${i?.displayWidth} ein:`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Inserisci un valore compreso tra 1 e ${i?.displayWidth}:`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Введите значение от 1 до ${i?.displayWidth}:`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Introduzca un valor entre 1 y ${i?.displayWidth}:`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`请输入介于 1 和 ${i?.displayWidth} 之间的值：`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`1 から ${i?.displayWidth} までの値を入力してください:`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`1 और ${i?.displayWidth} के बीच कोई मान दर्ज करें:`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Insira um valor entre 1 e ${i?.displayWidth}:`)
	return /** @type {LocalizedString} */ (`Enter a value between 1 and ${i?.displayWidth}:`)
});